import { useSession } from '../auth/session.js';
import { usePartTwoSetup } from '../lib/partTwoSetup.js';

/**
 * credify-platform#306 (operator ruling 2026-10-29) - on the Dashboard, for a practice admin who has not
 * submitted Onboarding Part Two: a reminder with Continue setup (signup's start route opens their Part
 * Two) and a dismiss that hides it until the next sign-in. Nothing for anyone else (lib/partTwoSetup.ts).
 */
export function PartTwoBanner() {
  const { user, impersonating } = useSession();
  const { status, showBanner, dismiss } = usePartTwoSetup(user, impersonating);
  if (!showBanner || !status) return null;
  return (
    <div className="p2setup-banner" role="status">
      <div className="p2setup-text">
        <div className="p2setup-title">Finish your EHR setup</div>
        <div className="p2setup-sub">
          Your practice is live. A few more answers (appointment types, hours, fees) set up the EHR
          the way your practice works. Everything you entered is saved.
        </div>
      </div>
      <div className="p2setup-actions">
        <a className="btn primary" href={status.startUrl}>
          Continue setup
        </a>
        <button
          type="button"
          className="p2setup-dismiss"
          aria-label="Hide until next sign-in"
          title="Hide until next sign-in"
          onClick={dismiss}
        >
          ×
        </button>
      </div>
    </div>
  );
}
